import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import Typography from "@mui/material/Typography";

export default function ({open, onClose}) {
    if (!open) return null;

    return <Modal
        modalConfig={
            new ModalConfig()
                .setHeight("80%")
                .setWidth("100%")
                .setOnClose(onClose)
                .setComponent((
                    <div>
                        <Typography variant={"h6"}>
                            Que faut il mettre ?
                        </Typography>
                        <Typography>
                            Mettez le numéro de votre devis, d'un point de vue comptable. Pour rappel, les numéros de
                            devis doivent se suivre dans l'ordre croissant (du plus petit au plus grand).
                        </Typography>

                        <Typography mt={5} variant={"h6"}>
                            Pourquoi ?
                        </Typography>
                        <Typography>
                            Nous allons générer un devis au nom de votre entreprise, incluant les mentions légales
                            nécessaires, nous faisons cela dans le but de vous faire gagner du temps. Si vous ne le
                            souhaitez pas, vous pourrez passer la signature électronique et prendre en photo votre
                            propre devis papier.
                        </Typography>
                    </div>
                ))
        }
    />
}